/**
 * Created by dianwoda on 2018/1/31.
 */
export default {
  hotCity: [
    { cityName: '北京', pinYin: 'beijing', py: 'bj' },
    { cityName: '上海', pinYin: 'shanghai', py: 'sh' },
    { cityName: '天津', pinYin: 'tianjin', py: 'tj' },
    { cityName: '青岛', pinYin: 'qingdao', py: 'qd' },
    { cityName: '南京', pinYin: 'nanjing', py: 'nj' },
    { cityName: '杭州', pinYin: 'hangzhou', py: 'hz' },
    { cityName: '厦门', pinYin: 'xiamen', py: 'xm' },
    { cityName: '成都', pinYin: 'chengdu', py: 'cd' },
    { cityName: '深圳', pinYin: 'shenzhen', py: 'sz' },
    { cityName: '广州', pinYin: 'guangzhou', py: 'gz' },
    { cityName: '沈阳', pinYin: 'shenyang', py: 'sy' },
    { cityName: '武汉', pinYin: 'wuhan', py: 'wh' }
  ],
  cities: [
    { cityName: '北京', pinYin: 'beijing', py: 'bj' },
    { cityName: '包头', pinYin: 'baotou', py: 'bt' },
    { cityName: '北海', pinYin: 'beihai', py: 'bh' },
    { cityName: '宝鸡', pinYin: 'baoji', py: 'bj' },
    { cityName: '成都', pinYin: 'chengdu', py: 'cd' },
    { cityName: '重庆', pinYin: 'chongqing', py: 'cq' },
    { cityName: '长沙', pinYin: 'changsha', py: 'cs' },
    { cityName: '长春', pinYin: 'changchun', py: 'cc' },
    { cityName: '常州', pinYin: 'changzhou', py: 'cz' },
    { cityName: '常德', pinYin: 'changde', py: 'cd' },
    { cityName: '沧州', pinYin: 'cangzhou', py: 'cz' },
    { cityName: '承德', pinYin: 'chengde', py: 'cd' },
    { cityName: '长治', pinYin: 'changzhi', py: 'cz' },
    { cityName: '滁州', pinYin: 'chuzhou', py: 'cz' },
    { cityName: '大连', pinYin: 'dalian', py: 'dl' },
    { cityName: '东莞', pinYin: 'dongguan', py: 'dg' },
    { cityName: '大同', pinYin: 'datong', py: 'dt' },
    { cityName: '达州', pinYin: 'dazhou', py: 'dz' },
    { cityName: '鄂尔多斯', pinYin: 'eerduosi', py: 'eeds' },
    { cityName: '恩施', pinYin: 'enshi', py: 'es' },
    { cityName: '福州', pinYin: 'fuzhou', py: 'fz' },
    { cityName: '佛山', pinYin: 'foshan', py: 'fs' },
    { cityName: '抚顺', pinYin: 'fushun', py: 'fs' },
    { cityName: '抚州', pinYin: 'fuzhou', py: 'fz' },
    { cityName: '防城港', pinYin: 'fangchenggang', py: 'fcg' },
    { cityName: '广州', pinYin: 'guangzhou', py: 'gz' },
    { cityName: '贵阳', pinYin: 'guiyang', py: 'gy' },
    { cityName: '桂林', pinYin: 'guilin', py: 'gl' },
    { cityName: '广元', pinYin: 'guangyuan', py: 'gy' },
    { cityName: '广安', pinYin: 'guangan', py: 'ga' },
    { cityName: '杭州', pinYin: 'hangzhou', py: 'hz' },
    { cityName: '哈尔滨', pinYin: 'haerbin', py: 'heb' },
    { cityName: '合肥', pinYin: 'hefei', py: 'hf' },
    { cityName: '呼和浩特', pinYin: 'huhehaote', py: 'hhht' },
    { cityName: '海口', pinYin: 'haikou', py: 'hk' },
    { cityName: '黄山', pinYin: 'huangshan', py: 'hs' },
    { cityName: '呼伦贝尔', pinYin: 'hulunbeier', py: 'hlbe' },
    { cityName: '邯郸', pinYin: 'handan', py: 'hd' },
    { cityName: '衡阳', pinYin: 'hengyang', py: 'hy' },
    { cityName: '汉中', pinYin: 'hanzhong', py: 'hz' },
    { cityName: '济南', pinYin: 'jinan', py: 'jn' },
    { cityName: '济宁', pinYin: 'jining', py: 'jn' },
    { cityName: '九江', pinYin: 'jiujiang', py: 'jj' },
    { cityName: '景德镇', pinYin: 'jingdezhen', py: 'jdz' },
    { cityName: '吉林', pinYin: 'jilin', py: 'jl' },
    { cityName: '江门', pinYin: 'jiangmen', py: 'jm' },
    { cityName: '晋城', pinYin: 'jincheng', py: 'jc' },
    { cityName: '嘉峪关', pinYin: 'jiayuguan', py: 'jyg' },
    { cityName: '酒泉', pinYin: 'jiuquan', py: 'jq' },
    { cityName: '昆明', pinYin: 'kunming', py: 'km' },
    { cityName: '克拉玛依', pinYin: 'kelamayi', py: 'klmy' },
    { cityName: '兰州', pinYin: 'lanzhou', py: 'lz' },
    { cityName: '丽江', pinYin: 'lijiang', py: 'lj' },
    { cityName: '洛阳', pinYin: 'luoyang', py: 'ly' },
    { cityName: '柳州', pinYin: 'liuzhou', py: 'lz' },
    { cityName: '泸州', pinYin: 'luzhou', py: 'lz' },
    { cityName: '拉萨', pinYin: 'lasa', py: 'ls' },
    { cityName: '临汾', pinYin: 'linfen', py: 'lf' },
    { cityName: '乐山', pinYin: 'leshan', py: 'ls' },
    { cityName: '聊城', pinYin: 'liaocheng', py: 'lc' },
    { cityName: '丽水', pinYin: 'lishui', py: 'ls' },
    { cityName: '绵阳', pinYin: 'mianyang', py: 'my' },
    { cityName: '梅州', pinYin: 'meizhou', py: 'mz' },
    { cityName: '眉山', pinYin: 'meishan', py: 'ms' },
    { cityName: '南昌', pinYin: 'nanchang', py: 'nc' },
    { cityName: '南京', pinYin: 'nanjing', py: 'nj' },
    { cityName: '南宁', pinYin: 'nanning', py: 'nn' },
    { cityName: '宁波', pinYin: 'ningbo', py: 'nb' },
    { cityName: '南通', pinYin: 'nantong', py: 'nt' },
    { cityName: '南充', pinYin: 'nanchong', py: 'nc' },
    { cityName: '内江', pinYin: 'neijiang', py: 'nj' },
    { cityName: '萍乡', pinYin: 'pingxiang', py: 'px' },
    { cityName: '攀枝花', pinYin: 'panzhihua', py: 'pzh' },
    { cityName: '青岛', pinYin: 'qingdao', py: 'qd' },
    { cityName: '泉州', pinYin: 'quanzhou', py: 'qz' },
    { cityName: '上海', pinYin: 'shanghai', py: 'sh' },
    { cityName: '深圳', pinYin: 'shenzhen', py: 'sz' },
    { cityName: '沈阳', pinYin: 'shenyang', py: 'sy' },
    { cityName: '石家庄', pinYin: 'shijiazhuang', py: 'sjz' },
    { cityName: '苏州', pinYin: 'suzhou', py: 'sz' },
    { cityName: '三亚', pinYin: 'sanya', py: 'sy' },
    { cityName: '汕头', pinYin: 'shantou', py: 'st' },
    { cityName: '上饶', pinYin: 'shangrao', py: 'sr' },
    { cityName: '遂宁', pinYin: 'suining', py: 'sn' },
    { cityName: '宿迁', pinYin: 'suqian', py: 'sq' },
    { cityName: '天津', pinYin: 'tianjin', py: 'tj' },
    { cityName: '太原', pinYin: 'taiyuan', py: 'ty' },
    { cityName: '台州', pinYin: 'taizhou', py: 'tz' },
    { cityName: '唐山', pinYin: 'tangshan', py: 'ts' },
    { cityName: '铁岭', pinYin: 'tieling', py: 'tl' },
    { cityName: '武汉', pinYin: 'wuhan', py: 'wh' },
    { cityName: '无锡', pinYin: 'wuxi', py: 'wx' },
    { cityName: '温州', pinYin: 'wenzhou', py: 'wz' },
    { cityName: '乌鲁木齐', pinYin: 'wulumuqi', py: 'wlmq' },
    { cityName: '威海', pinYin: 'weihai', py: 'wh' },
    { cityName: '渭南', pinYin: 'weinan', py: 'wn' },
    { cityName: '西安', pinYin: 'xian', py: 'xa' },
    { cityName: '厦门', pinYin: 'xiamen', py: 'xm' },
    { cityName: '香港', pinYin: 'xianggang', py: 'xg' },
    { cityName: '徐州', pinYin: 'xuzhou', py: 'xz' },
    { cityName: '西宁', pinYin: 'xining', py: 'xn' },
    { cityName: '襄阳', pinYin: 'xiangyang', py: 'xy' },
    { cityName: '新余', pinYin: 'xinyu', py: 'xy' },
    { cityName: '许昌', pinYin: 'xuchang', py: 'xc' },
    { cityName: '信阳', pinYin: 'xinyang', py: 'xy' },
    { cityName: '银川', pinYin: 'yinchuan', py: 'yc' },
    { cityName: '宜昌', pinYin: 'yichang', py: 'yc' },
    { cityName: '烟台', pinYin: 'yantai', py: 'yt' },
    { cityName: '扬州', pinYin: 'yangzhou', py: 'yz' },
    { cityName: '宜宾', pinYin: 'yibin', py: 'yb' },
    { cityName: '运城', pinYin: 'yuncheng', py: 'yc' },
    { cityName: '榆林', pinYin: 'yulin', py: 'yl' },
    { cityName: '盐城', pinYin: 'yancheng', py: 'yc' },
    { cityName: '岳阳', pinYin: 'yueyang', py: 'yy' },
    { cityName: '延安', pinYin: 'yanan', py: 'ya' },
    { cityName: '鹰潭', pinYin: 'yingtan', py: 'yt' },
    { cityName: '永州', pinYin: 'yongzhou', py: 'yz' },
    { cityName: '郑州', pinYin: 'zhengzhou', py: 'zz' },
    { cityName: '珠海', pinYin: 'zhuhai', py: 'zh' },
    { cityName: '张家界', pinYin: 'zhangjiajie', py: 'zzj' },
    { cityName: '中山', pinYin: 'zhongshan', py: 'zs' },
    { cityName: '遵义', pinYin: 'zunyi', py: 'zy' },
    { cityName: '湛江', pinYin: 'zhanjiang', py: 'zj' },
    { cityName: '株洲', pinYin: 'zhuzhou', py: 'zz' },
    { cityName: '肇庆', pinYin: 'zhaoqing', py: 'zq' },
    { cityName: '枣庄', pinYin: 'zaozhuang', py: 'zz' },
    { cityName: '舟山', pinYin: 'zhoushan', py: 'zs' },
    { cityName: '自贡', pinYin: 'zigong', py: 'zg' },
    { cityName: '资阳', pinYin: 'ziyang', py: 'zy' },
    { cityName: '张掖', pinYin: 'zhangye', py: 'zy' }
  ]
};




// WEBPACK FOOTER //
// ./packages/wxc-city/default-data.js